var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg27(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 25.4629L24.9961 34.5352V0L9.375 25.4629Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 0V34.5352L40.6172 25.4629L24.9961 0Z",
    fill: "#878787"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18.4902L40.6152 25.4629L25 34.5312V18.4883V18.4902Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 18.4883H25V34.5312L24.9961 34.5352L9.375 25.4648L24.9961 18.4902V18.4883Z",
    fill: "#999999"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 28.373L24.9961 49.998V37.4395L9.375 28.373Z",
    fill: "#D7D7D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9961 37.4414V50L40.625 28.375L24.9961 37.4414Z",
    fill: "#878787"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7441 25.4883C44.5137 25.4883 50 30.9746 50 37.7441C50 44.5137 44.5137 50 37.7441 50C30.9746 50 25.4883 44.5137 25.4883 37.7441C25.4883 30.9746 30.9746 25.4883 37.7441 25.4883Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2246 37.7441L32.2344 40.9844L34.9883 42.6055V44.502L30.623 41.9414V36.7949L32.2266 37.7422L32.2246 37.7441ZM32.2246 34.5039V36.3926L30.6211 35.4434V33.5547L32.2246 32.6055L33.8359 33.5547L32.2246 34.5039ZM36.1367 33.5547L37.7402 32.6055L39.3516 33.5547L37.7402 34.5039L36.1367 33.5547ZM33.3828 40.3125V38.416L34.9863 39.3652V41.2539L33.3828 40.3145V40.3125ZM36.1367 43.2852L37.7402 44.2344L39.3516 43.2852V45.1738L37.7402 46.123L36.1367 45.1738V43.2852ZM41.6523 33.5547L43.2559 32.6055L44.8672 33.5547V35.4434L43.2559 36.3926V34.5039L41.6523 33.5547ZM43.2559 40.9844L43.2656 37.7441L44.8691 36.7949V41.9414L40.5039 44.502V42.6055L43.2559 40.9863V40.9844ZM42.1055 40.3125L40.502 41.252V39.3633L42.1055 38.4141V40.3105V40.3125ZM42.1055 35.1758L42.1152 37.0723L39.3535 38.6934V41.9414L37.75 42.8809L36.1465 41.9414V38.6934L33.3848 37.0723V35.1758L34.9961 34.2266L37.7402 35.8555L40.502 34.2266L42.1133 35.1758H42.1055ZM33.3828 31.9355L37.7402 29.3672L42.1055 31.9355L40.502 32.8848L37.7402 31.2559L34.9863 32.8848L33.3828 31.9355Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg27);
export default __webpack_public_path__ + "static/media/27.5f7fe3243137f119ae8ab7c93d39546d.svg";
export { ForwardRef as ReactComponent };